var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fastComments"},[_c('fast-comments',{key:("fastcomments-" + _vm.locale),attrs:{"config":{ tenantId: 'DI1IvcHUcUJB', urlId: _vm.urlId, simpleSSO: _vm.userData, locale: _vm.locale }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }